import { Component, OnInit } from "@angular/core";
import { SelectItem, MenuItem } from "primeng/api";
import { BreadcrumbService } from "../../breadcrumb.service";
import { ActivatedRoute } from "@angular/router";
import { User } from "../domain/user";
import { UserService } from "../service/user.service";
import { Company } from "../domain/company";
import { CompanyService } from "../service/company.service";
import { Router } from "@angular/router";
import { AuthGuardService } from "../service/authguardservice";
import { Configuration } from "../domain/configuration";
import * as $ from 'jquery';
import { MessageService } from 'primeng/api';
import { JwtHelperService } from "@auth0/angular-jwt";
import { HostListener } from '@angular/core';

@Component({
    templateUrl: "./user-restricted.edit.component.html",
    host: {
    '(document:keypress)': 'handleKeyboardEvent($event)'
    }
})
export class UserRestrictedEditComponent implements OnInit {

    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.keyCode == 27)
        {
            this.cancel();
        }
        if (event.keyCode == 13)
        {
            this.saveClose();
        }
    }

    id: string;

    object = new User();

    timeStamp = new Date().getTime();

    urlPicture: string;

    urlPicturePost: string;
    
    response: any;

    allowUpload: boolean = false;
    
    imageToUpload: any;

    isDisabled: boolean = false; 

    constructor(
        private breadcrumbService: BreadcrumbService,
        private route: ActivatedRoute,
        private userService: UserService,
        private companyService: CompanyService,
        private router: Router,
        private authGuard: AuthGuardService,
        private messageService: MessageService,
        private jwtHelper : JwtHelperService
    ) {
        const token = this.jwtHelper.decodeToken(localStorage.getItem('jwt'));
        this.id = token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid'];

       
    }

    ngOnInit() {
        if (this.id === "new") {
            this.object = new User();
        } else {
            this.userService
                .getById(this.id)
                .then(user => (this.object = user))
                .then(user => {
                    this.breadcrumbService.setItems([
                        { label: "Users", routerLink: ["/users"] },
                        {
                            label: this.object.Name,
                            routerLink: ["/users/" + this.id]
                        }
                    ]);
                });
        }
        this.urlPicturePost = Configuration.server + "/api/users/" + this.id;
        this.urlPicture =
            Configuration.server + "/api/users/" + this.id + "/photo";
        var pictureLink = this.getLinkPicture();
        this.GetImage(pictureLink);
    }

    saveClose() {
        this.isDisabled=true;
        this.userService
            .put(this.object, this.id)
            .then(user=>{
                this.isDisabled=false;
                this.router.navigate(["../"]);
            })
            .catch(error => {
                this.isDisabled=false;
                this.ngOnInit();
            }); 

    }

    save() {
        this.isDisabled=true;
        this.userService
            .put(this.object, this.id)
            .then(user=>{
                this.isDisabled=false;
                this.router.navigate(["/users/"+user.id]);
            })
            .catch(error => {
                this.isDisabled=false;
                this.ngOnInit();
            }); 

    }

    cancel() {
        this.router.navigate(["../"]);
    }

    public GetImage(url)
    {
        var http = new XMLHttpRequest();
        http.open('GET', url, true);
        http.responseType = "blob";
        let token = localStorage.getItem('jwt');
        http.setRequestHeader('Authorization', 'Bearer ' + token);
        http.onload = this.loadImage;
        http.send();
    } 

    public loadImage(e) {
        var urlCreator = window.URL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        $("#photoToUpload").attr('src', imageUrl);
    }

    public ImageExists(url)
    {
        var http = new XMLHttpRequest();
        http.open('GET', url, false);
        let token = localStorage.getItem('jwt');
        http.setRequestHeader('Authorization', 'Bearer ' + token);
        http.send();
        return http.status!=404;
    }

    public getLinkPicture() {
        if (this.timeStamp) {
            if (this.ImageExists(this.urlPicture + "?" + this.timeStamp)) {
                return this.urlPicture + "?" + this.timeStamp;
            } else {
                return "../assets/layout/images/user-image-placeholder.png";
            }
        }
        return this.urlPicture;
    }

    public setLinkPicture(url: string) {
        this.urlPicture = url;
        this.timeStamp = new Date().getTime();
    }

    onUpload(event) {
        if (this.allowUpload) {
            this.setLinkPicture(this.urlPicture);
            this.messageService.add({
                severity: 'success',
                summary: 'Image successfully uploaded!'
            });
        }
    }

    onPictureSelect(event) {
        this.allowUpload = false;
        this.imageToUpload = undefined;

        if (event.files[0]) {
            this.imageToUpload = event.files[0];
            //check if file is larger than 0,5MB
            if (event.files[0].size / 1000000 > 0.5) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Can not upload image',
                    detail: 'Image is larger than allowed (0,5 MB)! Please choose another image.'
                });
                return;
            }
            console.log(this.imageToUpload);
            //check if image is square
            var img = new Image();
            img.onload = () => {
                if (img.width !== img.height) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Can not upload image',
                        detail: 'Only square images can be uploaded as profile photos! For example (in pixels): 200x200, 400x400 etc.'
                    });
                    return;
                } else {
                    this.setImageToUploadPhoto(this.imageToUpload);
                }
            }
            img.src = window.URL.createObjectURL(this.imageToUpload);
        }
    }

    setImageToUploadPhoto(src) {
        var reader = new FileReader();

        reader.onload = function (e) {
            $('#photoToUpload').hide();
            $('#uploadedPhotoWrapper').html('<img id="photoToUpload" />');
            $('#photoToUpload')
                .attr('src', reader.result as string)
                .height(100)
                .width("auto");
        };

        reader.readAsDataURL(src);

        this.allowUpload = true;
    }
}
